import React from "react";
import { motion } from "framer-motion";

const GemsRain = () => {
  const numberOfFlowers = 20; // Number of flowers raining

  // Array of flower images (Make sure these images exist in the public folder)
  const flowerImages = ["/gems1.png", "/gems2.png", "/Gems3.png"];

  // Function to generate random values for smooth variation in animation
  const randomValue = (min, max) => Math.random() * (max - min) + min;

  return (
    <div className="fixed top-0 left-0 w-full h-full z-10 pointer-events-none">
      {Array.from({ length: numberOfFlowers }).map((_, i) => {
        const delay = randomValue(0, 5); // Different delay for each flower
        const duration = randomValue(5, 10); // Different speed
        const startX = randomValue(0, 100); // Random start position
        const endX = startX + randomValue(-20, 20); // Small variation in drift
        const flowerSrc =
          flowerImages[Math.floor(Math.random() * flowerImages.length)]; // Randomly pick a flower image

        return (
          <motion.img
            key={i}
            src={flowerSrc} // Random flower image
            alt="Flower"
            style={{
              position: "absolute",
              width: `${randomValue(30, 60)}px`, // Random sizes
              left: `${startX}vw`,
              top: "-10vh",
              opacity: randomValue(0.7, 1), // Slight transparency
            }}
            animate={{
              y: ["-10vh", "110vh"], // Moves from top to bottom
              x: [`${startX}vw`, `${endX}vw`], // Slight horizontal movement
              rotate: [0, 360], // Adds spinning effect
            }}
            transition={{
              duration: duration,
              delay: delay,
              repeat: Infinity,
              ease: "linear",
            }}
          />
        );
      })}
    </div>
  );
};

export default GemsRain;
